import React from 'react'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { Box, Flex, Text } from '@fundamentals'
import EastIcon from '@mui/icons-material/East'
import { TimelineBlockBase } from '@common/Timeline'
import { localizedStrings } from '@core/strings'

type ComponentProps = {
  nominatedForApproval: AuditResult['metadata']['nominatedForApproval']
  nominatedApprovers: AuditResult['metadata']['nominatedApprovers']
}

export const TimelineApprovalNominationBlock: React.FC<ComponentProps> = ({
  nominatedApprovers,
  nominatedForApproval,
}) => {
  return (
    <TimelineBlockBase
      title={`${localizedStrings.notifiedApprovers} for ${nominatedForApproval}`}
    >
      {nominatedApprovers.map((nominee) => {
        return (
          <Flex
            key={nominee.id}
            alignItems='center'
            justifyContent='flex-start'
          >
            <EastIcon sx={{ mx: 2, opacity: 0.5 }} />
            <Box>
              <Text>{nominee.getFullName()}</Text>
              <Text fontSize={12}>{nominee.company}</Text>
            </Box>
          </Flex>
        )
      })}
    </TimelineBlockBase>
  )
}
